import { takeLatest } from 'redux-saga/effects';

import { SAVE_REFERRAL_SUCCESS as SAVE_REFERRAL_SUCCESS_HEADER } from 'containers/Header/constants';
import { SAVE_REFERRAL_SUCCESS as SAVE_REFERRAL_SUCCESS_OUTBOUND } from 'modules/Referrals/pages/ReferralsForm/OutboundReferralsForm/constants';
import { SAVE_REFERRAL_SUCCESS } from 'modules/Referrals/pages/ReferralsForm/InboundReferralsForm/constants';
import { SAVE_REFERRALS_STATUS_SUCCESS } from 'modules/Referrals/constants';

import sagaRelayInvalidateData from './sagaRelayInvalidateData';

function* sagaInvalidateStore() {
  yield sagaRelayInvalidateData('Referral');
}

export default function* sagaWatchersReferral() {
  // Invalidate data on Relay store and refetch queries
  yield takeLatest(SAVE_REFERRAL_SUCCESS_HEADER, sagaInvalidateStore);
  yield takeLatest(SAVE_REFERRAL_SUCCESS_OUTBOUND, sagaInvalidateStore);
  yield takeLatest(SAVE_REFERRAL_SUCCESS, sagaInvalidateStore);
  yield takeLatest(SAVE_REFERRALS_STATUS_SUCCESS, sagaInvalidateStore);
}
